export default __webpack_public_path__ + "static/media/Hindia - Secukupnya (Lyric Video) - OST. Nanti Kita Cerita Tentang Hari Ini.769042bf.mp3";